// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const machineStatusItemToUpdate = item => ({
    item,
    type: actions.UPDATE_TCSM_MACHINE_STATUS_ITEM_TO_UPDATE
});

export const updateCommentsToDealer = comments => ({
    comments,
    type: actions.UPDATE_TCSM_MACHINE_STATUS_COMMENTS_TO_DEALER
});

export const updateInternalDeereComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_MACHINE_STATUS_INTERNAL_DEERE_COMMENTS
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/machine-status-item-to-update.js